<template>
  <p class="text-h6 mb-2">{{ $t("component.notFoundModel.finalTitle") }}</p>
  <p class="text-body-2 mb-4 text-on-surface-variant">
    {{ $t("component.notFoundModel.finalDescription") }}
  </p>

  <v-text-field
    v-model.trim="finalModel"
    class="mb-2"
    variant="underlined"
    :label="$t('component.notFoundModel.modelLabel')"
    color="primary"
  />

  <v-text-field
    :model-value="valueDisplay"
    class="mb-2"
    variant="underlined"
    inputmode="numeric"
    :label="$t('component.notFoundModel.valueLabel')"
    color="primary"
    @update:model-value="onValueInput"
  >
    <template #append-inner>
      <v-tooltip location="top" max-width="260">
        <template #activator="{ props: activatorProps }">
          <v-icon v-bind="activatorProps" size="18" color="grey-darken-1">
            mdi-help-circle-outline
          </v-icon>
        </template>
        <span>{{ $t("component.notFoundModel.valueTooltip") }}</span>
      </v-tooltip>
    </template>
  </v-text-field>

  <v-btn
    block
    color="primary"
    class="mt-4"
    :disabled="!isFinalValid || loading"
    :loading="loading"
    @click="onSubmitClick"
  >
    {{ $t("component.notFoundModel.submitButton") }}
  </v-btn>
</template>

<script setup lang="ts">
  import { computed, ref } from "vue";

  import {
    formatCurrencyDisplay,
    parseCurrencyDigits,
    parseValueNumber,
  } from "../notFoundModel.utils";

  defineProps<{ loading: boolean }>();
  const emit = defineEmits<{
    submit: [payload: { model: string; value: number }];
  }>();

  const finalModel = ref("");
  const valueDigits = ref("");

  const valueDisplay = computed(() => formatCurrencyDisplay(valueDigits.value));
  const valueNumber = computed(() => parseValueNumber(valueDigits.value));
  const isFinalValid = computed(() => finalModel.value.length > 0 && valueNumber.value > 0);

  function onValueInput(raw: string) {
    valueDigits.value = parseCurrencyDigits(raw);
  }

  function onSubmitClick() {
    if (!isFinalValid.value) {
      return;
    }

    emit("submit", { model: finalModel.value, value: valueNumber.value });
  }
</script>
